import { ChakraProvider } from '@chakra-ui/react'
import { theme } from './theme/theme'
import { RouterProvider } from 'react-router-dom'
import AuthProvider from './context/Auth'
import { UserModuleProvider } from './contexts/UserModuleContext'
import { AIChatProvider } from './contexts/AIChatContext'
import { CHUConfigProvider } from './contexts/CHUConfigContext'
import { useMyProfileWithModules } from './api/api_hooks/user/myProfile'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { router } from './routing/root'

const queryClient = new QueryClient()

// Wrapper component to access the user data with modules
const AppContent: React.FC = () => {
  const { data: userWithModules, isLoading } = useMyProfileWithModules()

  return (
    <UserModuleProvider user={userWithModules || null} isLoading={isLoading}>
      <CHUConfigProvider>
        <AIChatProvider>
          <ChakraProvider theme={theme}>
            <RouterProvider router={router} />
          </ChakraProvider>
        </AIChatProvider>
      </CHUConfigProvider>
    </UserModuleProvider>
  )
}

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
